export var PREFIX_CLS = 'ant-fullcalendar';